import script from "./RenderTranslation.vue?vue&type=script&lang=js"
export * from "./RenderTranslation.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__